import { GoogleAnalyticsPlugin, YandexAnalyticsPlugin } from 'integrations';

export enum AnalyticGoals {
	SUBSCRIPTION_MENU_ENTER = "SubscriptionMenuEnter",
	SUBSCRIPTION_MODAL_OPENED = "SubscriptionModalEnter"
}

export interface IAnalyticsService {
	visit(page: IAnalyticsPage): void;
	onGoalReached(goal: AnalyticGoals): void;
}
export interface IAnalyticsPage {
	visitUrl: string;
	title: string;
	params: { [key: string]: string };
}

const composite = (...services: IAnalyticsService[]): IAnalyticsService => {
	return {
		visit: (page: IAnalyticsPage) => {
			for (const service of services)
				service.visit(page);
		},
		onGoalReached: (goal: AnalyticGoals) => {
			for (const service of services)
				service.onGoalReached(goal);
		}
	};
}

const YandexMetrica: IAnalyticsService = {
	visit: (page: IAnalyticsPage) => {
		YandexAnalyticsPlugin.trackVisit(page.visitUrl, page.title, page.params);
	},
	onGoalReached: (goal: AnalyticGoals) => {
		YandexAnalyticsPlugin.reachGoal(goal);
	}
};

const GoogleAnalysics: IAnalyticsService = {
	visit: (page: IAnalyticsPage) => {
		GoogleAnalyticsPlugin.trackVisit(page.visitUrl);
	},
	onGoalReached: () => { }
};

export const AnalyticsService = composite(YandexMetrica, GoogleAnalysics);